import React, { useCallback } from 'react';
import './ChoiceItem.less';
import classNames from 'classnames';
import { IDialogOptions } from 'components/Dialogs/EitherOrDialog/typings';

export interface IChoiceItem {
  id: string;
  /**
   * Choice title
   */
  title: string;
  /**
   * On small resolutions we cannot show sidebar and choices go to dialogs buttons panel.
   * This property allows to set alternative text for choice when it goes to buttons panel.
   * By default @param title is used
   */
  asButtonText?: string;
  /**
   * Customize choices illustration
   */
  illustration: {
    url?: string;
    className?: string;
  };
  /**
   * Text of button which is displayed below an illustration
   */
  buttonText: string;
  /**
   * Property is supposed to be used when need to perform some action instead of changing content.
   *
   * @returns whether need to choose item
   */
  handle?: (item: IChoiceItem) => boolean;
  /**
   * Options will be applied to the dialog when choice is selected.
   */
  dialogOptions: IDialogOptions;
}

export interface IChoiceItemProps {
  item: IChoiceItem;
  isInSidePanel: boolean;
  showIllustrations: boolean;
  onChoose: (item: IChoiceItem) => void;
}

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ChoiceItem({ item, isInSidePanel, showIllustrations, onChoose }: IChoiceItemProps) {
  const handleChoose = useCallback(() => onChoose(item), [item, onChoose]);

  return (
    <li
      className={classNames('dpc-choice-item', {
        'dpc-choice-item--sidebar': isInSidePanel,
      })}
    >
      {showIllustrations && (
        <div
          onClick={handleChoose}
          className={classNames('dpc-choice-item__illustration', item.illustration.className)}
          style={{ backgroundImage: item.illustration.url ? `url(${item.illustration.url})` : undefined }}
        />
      )}
      <button
        className={classNames('dpc-choice-item__choose', {
          'dpc-choice-item__choose--button': !isInSidePanel,
          'dpc-choice-item__choose--link': isInSidePanel,
        })}
        title={item.buttonText}
        onClick={handleChoose}
      >
        {item.buttonText}
      </button>
    </li>
  );
}
